module.exports = __webpack_public_path__ + "fonts/visuelt-pro-medium.4d0721dd.eot";